import { render } from "./SearchableGroupableList.vue?vue&type=template&id=fa2fb41e&scoped=true"
import script from "./SearchableGroupableList.vue?vue&type=script&lang=js"
export * from "./SearchableGroupableList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2fb41e"]])

export default __exports__